import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LineItemMonitorComponent } from "./line-item-monitor/line-item-monitor.component";
import { TrendLimComponent } from "./trend-lim/trend-lim.component";
import { LineItemMonitorGridComponent } from "./line-item-monitor-grid/line-item-monitor-grid.component";
import { LineItemEditModalComponent } from "./line-item-edit-modal/line-item-edit-modal.component";

import { IconsModule } from "@va/core-library/icons";
import { RevisionLimComponent } from "./revision-lim/revision-lim.component";
import { FormsModule } from "@angular/forms";
import { DispersionLimComponent } from "./dispersion-lim/dispersion-lim.component";
import { SharedModule } from "../shared/shared.module";
import { LineItemPeriodEditComponent } from "./line-item-period-edit/line-item-period-edit.component";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { LineItemLinksComponent } from "./line-item-links/line-item-links.component";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzMenuModule } from "ng-zorro-antd/menu";
@NgModule({
  declarations: [
    LineItemMonitorComponent,
    TrendLimComponent,
    LineItemMonitorGridComponent,
    LineItemEditModalComponent,
    RevisionLimComponent,
    DispersionLimComponent,
    LineItemPeriodEditComponent,
    LineItemLinksComponent,
  ],
  bootstrap: [LineItemEditModalComponent],
  imports: [
    CommonModule,
    NzGridModule,
    IconsModule,
    FormsModule,
    SharedModule,
    ChartPlotterModule,
    NzModalModule,
    NzSkeletonModule,
    NzTableModule,
    NzPopoverModule,
    NzDividerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    NzDropDownModule,
    NzTabsModule,
    NzRadioModule,
    NzMenuModule,
  ],
  exports: [LineItemMonitorComponent],
})
export class LineItemMonitorModule {}
